import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => {
  const { secondary } = theme.palette;
  const { yellow } = theme.palette.common;

  return {
    TextField: {
      'position': 'relative',
      'boxSizing': 'border-box',
      'border': `2px solid`,
      'borderColor': 'transparent',
      'minWidth': '222px',
      'height': '34px',
      'maxHeight': '34px',
      'display': 'flex',
      'alignItems': 'center',
      'justifyContent': 'flex-start',
      'padding': 0,
      'flex': 1,

      '& .ThemedTextField__container': {
        'alignItems': 'center',
        'width': '100%',
        'height': '34px',
        '&::after': {
          transition: 'backgroundColor 200ms ease',
          position: 'absolute',
          content: '""',
          width: '100%',
          height: '2px',
          left: '0',
          bottom: '-2px',
        },
      },
      '& .ThemedTextField__icon--start': {
        borderRadius: '50%',
        width: '16px',
        marginRight: '8px',
        height: '16px',
        fill: '#616161',
      },
      '& .ThemedTextField__unit': {
        display: 'flex',
        alignItems: 'center',
        fontFamily: 'Quicksand',
        fontSize: '14px',
        color: '#b6b6b6',
        marginRight: '5px',
        padding: '8px 0',
      },
    },
    TextField_Multiline: {
      'height': 'min-content',
      'maxHeight': 'min-content',
      '& .ThemedTextField__container': {
        height: 'min-content',
        paddingBottom: '7px',
      },
    },
    TextField_Outline: {
      padding: '0 10px',
    },
    TextField_Empty: {
      borderColor: secondary.main,
    },
    TextField_Filled: {
      '& .ThemedTextField__container::after': {
        backgroundColor: '#b6b6b6',
      },
      '&:hover .ThemedTextField__container::after': {
        backgroundColor: yellow,
      },
    },
    TextField_Focused: {
      'borderColor': 'transparent',
      '& .ThemedTextField__container::after': {
        backgroundColor: yellow,
      },
      '& .ThemedTextField__icon--start': {
        fill: '#292929',
      },
    },
    TextField_Disabled: {
      'borderColor': 'transparent',
      '& .ThemedTextField__container::after': {
        backgroundColor: 'transparent',
        borderBottom: '2px dotted #ddd5e4',
      },
      '&:hover .ThemedTextField__container::after': {
        backgroundColor: 'transparent',
      },
    },
    TextField_Invalid: {
      'borderColor': 'transparent',
      '& .ThemedTextField__container::after': {
        backgroundColor: '#e35d7d',
      },
      '&:hover .ThemedTextField__container::after': {
        backgroundColor: '#e35d7d',
      },
    },
    TextField__input: {
      'position': 'relative',
      'fontSize': '14px',
      'fontFamily': 'Quicksand',
      'fontWeight': '500',
      'padding': '0',
      'width': '100%',
      '& input': {
        padding: '8px 0',
      },
    },
    TextField__icon: {
      borderRadius: '50%',
      width: '24px',
      height: '24px',
      fill: '#292929',
    },
    TextField__icon_clear: {
      borderRadius: '50%',
      width: '16px',
      height: '16px',
      backgroundColor: '#f1f1f1',
    },
    TextField__icon_button: {
      marginRight: '-5px',
    },
    Dropdown__item: {
      margin: '0 5px',
    },
    Dropdown__selected: {
      backgroundColor: '#eee !important',
      color: '#292929 !important',
    },
    Dropdown__divider: {
      margin: '15px 5px 0',
      borderTop: `3px solid ${yellow}`,
    },
    Dropdown__Menu: {
      boxShadow: '0 0 8px 0 rgba(0,0,0,0.3)',
      borderRadius: '0 0 8px 8px',
      boxSizing: 'border-box',
      marginTop: 3,
    },
  };
});
